import script from "./IconCurvedArrowRight.vue?vue&type=script&setup=true&lang=ts"
export * from "./IconCurvedArrowRight.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__